const removeSpecialsCharacters = (str: string) => {
  // eslint-disable-next-line
  const newStr = str.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');  
  return newStr;
}

export default removeSpecialsCharacters;